import React, { useRef, useEffect } from "react"

import { af as AF } from "@gladeye/af"

const Parallax = ({ children, movement, cStyle, pStyle, rotation = 0 }) => {
    const parent = useRef()
    const child = useRef()
    const af = AF()

    useEffect(() => {
        let animVal = 0
        let shift = 0
        let rot = 0

        function read() {
            const { top, height } = parent.current.getBoundingClientRect()
            const wh = window.innerHeight
            const middle = top + height * 0.5
            const normalize = middle / wh
            const val = normalize * 2 - 1

            animVal += (val - animVal) * 0.2
            shift = wh * movement * animVal

            rot = rotation * 360 * animVal
        }

        function write() {
            child.current.style.transform = `translate3d(0,${shift}px,1px) ${
                rot == 0 ? "" : `rotateZ(${rot}deg)`
            }`
        }

        af.addRead(read)
        af.addWrite(write)

        return () => {
            af.removeRead(read)
            af.removeWrite(write)
        }
    }, [])

    return (
        <div ref={parent} style={pStyle}>
            <div style={cStyle} ref={child}>
                {children}
            </div>
        </div>
    )
}

export default Parallax
